import React, { useState, useEffect, MouseEvent } from 'react';
import StyledInput from 'components/input/text';
import labels from 'constants/labels';
import { ModalButton, ModalTextButton } from 'components/modal-provider/modal';
import ModalBasic from 'components/modal-provider/modal-basic';
import { toast } from 'react-toastify';
import messages from 'constants/messages';
import BookmarkAddIcon from 'assets/svg/BookmarkAddIcon';
import BookmarkAddedIcon from 'assets/svg/BookmarkAddedIcon';
import styled from 'styled-components';
import { TAddNewBookmarkProps } from '.';
import './styles.scss';

export default function MyBookmark(props: TAddNewBookmarkProps) {
  const {
    clearModalContent,
    setModalContent,
    setBookmarkName,
    addBookmark,
    deleteBookmark,
    bookmarkLink,
    bookmarkName,
    bookmarkModule,
    bookmarks,
    addBookmarkSuccess,
  } = props;

  const BookmarkButton = styled.button`
    border: none;
    background-color: transparent;
  `;

  const [isBookmarkHovering, setIsBookmarkHovering] = useState(false);
  const [bookmarkNameUser, setBookmarkNameUser] = useState('');
  const [isBookmarkAdded, setIsBookmarkAdded] = useState(false);
  const [currentBookmark, setCurrentBookmark] = useState({ id: '', name: '', link: '', module: '' });

  useEffect(() => {
    if (bookmarks && bookmarks.length > 0) {
      bookmarks.some(bookmark => {
        if (bookmark.link === window.location.pathname) {
          setCurrentBookmark(bookmark);
          setIsBookmarkAdded(true);
          return true;
        }
        setIsBookmarkAdded(false);
        setBookmarkNameUser('');
        return false;
      });
    }
  });

  useEffect(() => {
    if (addBookmarkSuccess) {
      toast.dismiss();
      toast.success(`${bookmarkName} ${messages.success.bookmarkAdded}`, { autoClose: 3000 });
      clearModalContent();
    }
  }, [addBookmarkSuccess]); // eslint-disable-line react-hooks/exhaustive-deps

  function toggleBookmarkHover(_event: MouseEvent<HTMLButtonElement>) {
    setIsBookmarkHovering(!isBookmarkHovering);
  }

  const handleSave = (_name: string) => {
    addBookmark();
  };

  const handleCancel = () => {
    setBookmarkNameUser('');
    clearModalContent();
    toast.dismiss();
  };

  const handleDelete = () => {
    deleteBookmark(currentBookmark.id);
    toast.success(`${currentBookmark.name} ${messages.success.bookmarkDeleted}`, { autoClose: 3000 });
    clearModalContent();
    setBookmarkNameUser('');
  };

  function handleBookmarkModal() {
    const modalContent = (
      <>
        <p>Enter bookmark name</p>
        <StyledInput
          width="386px"
          placeholder="Enter bookmark name here"
          defaultValue={bookmarkNameUser}
          onChange={e => {
            setBookmarkNameUser(e.target.value);
          }}
          onBlur={e => {
            setBookmarkName(e.target.value, bookmarkLink, bookmarkModule);
          }}
        />
        <br />
      </>
    );
    const buttons = (
      <>
        <ModalTextButton onClick={handleCancel}>{labels.button.cancel}</ModalTextButton>
        <ModalButton onClick={() => handleSave(bookmarkName)}>{labels.button.save}</ModalButton>
      </>
    );
    const modal = (
      <ModalBasic title="Save bookmark" content={modalContent} onClose={clearModalContent} buttons={buttons} />
    );
    setModalContent(modal);
  }

  function handleBookmarkDeleteModal() {
    const modalContent = (
      <>
        <p>Are you sure you want to delete {currentBookmark.name} bookmark?</p>
        <br />
      </>
    );
    const buttons = (
      <>
        <ModalTextButton onClick={clearModalContent}>{labels.button.cancel}</ModalTextButton>
        <ModalButton onClick={() => handleDelete()}>{labels.button.delete}</ModalButton>
      </>
    );
    const modal = (
      <ModalBasic title="Delete bookmark?" content={modalContent} onClose={clearModalContent} buttons={buttons} />
    );
    setModalContent(modal);
  }

  return (
    <>
      {isBookmarkHovering && (
        <span className={`${'bookmark-animated '} ${bookmarkModule === 'Deal Comparison' ? 'bookmark-icon' : ''}`}>
          Save as bookmark
        </span>
      )}
      <>
        {isBookmarkAdded ? (
          <BookmarkButton onClick={handleBookmarkDeleteModal}>
            <BookmarkAddedIcon />
          </BookmarkButton>
        ) : (
          <BookmarkButton
            onMouseEnter={toggleBookmarkHover}
            onMouseLeave={toggleBookmarkHover}
            onClick={handleBookmarkModal}
          >
            <BookmarkAddIcon />
          </BookmarkButton>
        )}
      </>
    </>
  );
}
